import type { FC } from 'react'
import { useLayoutEffect, useState } from 'react'
import { BrowserRouterProps, Router } from 'react-router-dom'
import { BrowserHistory } from 'history'

import customHistory from '@/history'
interface Props extends BrowserRouterProps {
  history: BrowserHistory;
}
const AmCustomRouter:FC<Props> = ({ children, basename, history }:Props) => {
  const [state, setState] = useState({
    action: history.action,
    location: history.location
  })
  useLayoutEffect(() => history.listen(setState), [history])

  return (
    <Router
      navigator={customHistory}
      location={state.location}
      navigationType={state.action}
      // eslint-disable-next-line react/no-children-prop
      children={children}
      basename={basename}
    />
  )
}

export default AmCustomRouter
